import { defineComponent as i } from "vue";
import { DialogLayout as n, DIALOG_VARIANTS as r } from "@ado/acs-standard-library";
import "../../../base_application/ui/components/index2.js";
import "../../../base_application/ui/components/index3.js";
import "../../../base_application/ui/components/index4.js";
import "../../../shared/data/configuration/state/index2.js";
import "@ado/base-service";
import "@ado/location-library";
import "@ado/cookie-library";
import "../../../shared/data/csr/state/index2.js";
import { setShowSignInDialog as p } from "../../../shared/data/layout/state/index.js";
import "../../../shared/data/location/state/index.js";
import "../../../shared/data/navigation/state/index2.js";
import "@ado/experiment-library";
import "../../../search/state/index2.js";
import "../../../shared/data/user/state/index2.js";
import "../../../search/ui/components/available_contracts/index2.js";
import "@ado/translation-library";
import "../../../sign_in/ui/components/index2.js";
import "@ado/acs-standard-library/style.css";
const V = i({
  name: "ExpiredSessionDialog",
  components: {
    DialogLayout: n
  },
  props: {
    showDialog: {
      type: Boolean,
      default: !1
    }
  },
  setup(m, { emit: t }) {
    const o = () => {
      t("update:showDialog", !1);
    };
    return {
      handleSignInButtonClick: () => {
        o(), p(!0);
      },
      handleCancelButtonClick: () => {
        o();
      },
      DialogVariants: r
    };
  }
});
export {
  V as default
};
//# sourceMappingURL=index4.js.map
